import { Component, Input, OnInit } from "@angular/core";

import { ViewCell } from "ng2-smart-table";

@Component({
  template: `<label class="text-body" style="text-align: left;">
    {{ renderValue }}
  </label>`,
})
export class StbCustomRenderIdComponent implements ViewCell, OnInit {
  renderValue: string;

  @Input() value: string;
  @Input() rowData: any;

  ngOnInit() {
    this.renderValue =
      this.value && this.value.length > 6
        ? this.value.substring(this.value.length - 6, 6)
        : this.value;
  }
}
